import { HttpClient } from '@angular/common/http';
import {
    Injectable,
    isDevMode,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { TranslateLoader } from '@ngx-translate/core';

import { Observable } from 'rxjs';

@Injectable()
export class TranslationService implements TranslateLoader {
    protected _endpoint = '/api/translations';
    constructor(
        private _http: HttpClient,
        private _appState: AppStateFacade,
    ) { }

    getTranslation(lang: string): Observable<any> {
        const cacheBust = `${this._appState.authConfig.buildVersion}${
            isDevMode() ? +new Date() : ''
            }`;

        return this._http.get(
            `${this._endpoint}/GetTranslations?lang=${lang}&v=${cacheBust}`,
        );
    }
}
